import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import LanguageButton from "../language-button/component";
import ErrorHandler from "../error-handler/component";
import {agentRegister} from "../../services/agentRegister";
import Feed from "../feed/component";
import * as moment from 'moment';
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class userFeeds extends Component {

    constructor(props) {
        super(props);
        this.state = {
            feed_pref: {},
            feed_loader: true,
            feed_properties: [],
            status: false,
            currency: "",
            isLoading: true,
            switchLoader: false,
            error: false,
            edit_facebook: false,
            edit_google: false,
            edit_tiktok: false,
            edit_snapchat: false,
            lang_modal: false,
            daily_budget: ["50", "100", "150", "200", "250", "300", "350", "400", "450", "500", "550", "600", "650", "700", "750", "800", "850", "900", "950", "1000", "1050", "1100", "1150", "1200"],
            facebook_selected_daily_budget: "100",
            google_selected_daily_budget: "100",
            tiktok_selected_daily_budget: "100",
            snapchat_selected_daily_budget: "100",
            facebook_feed_status: false,
            google_feed_status: false,
            tiktok_feed_status: false,
            snapchat_feed_status: false,
            reseller_id: null,
            smartspend_feed_status: true,
            search_feed_status: true,
            proptree_status: false
        };
    };

    componentWillMount() {
        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/user/feeds');
            ReactGA4.send({ hitType: "pageview", page: "/user/feeds" });
        }
        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }

        this._updateCurrency();
        this._updateData();
        this._updateUser();
        this._updateFeed();
    }

    _signOut(){
        userRegister.remove();
        tokenRegister.remove();
        agentRegister.remove();
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
    }

    _updateCurrency() {
        let value = salesChannelRegister.get('currency').toUpperCase();
        this.setState({currency: value}, () =>
            console.log(this.state.currency)
        );
    }

    _updateData() {
        dataRegister.account(salesChannelRegister.get('market')).then((response) => {
            this.setState({
                feed_pref: response.feed_pref,
                facebook_selected_daily_budget: response.feed_pref.facebook_remarketing.daily_budget ? response.feed_pref.facebook_remarketing.daily_budget : this.state.facebook_selected_daily_budget,
                google_selected_daily_budget: response.feed_pref.google_remarketing.daily_budget ? response.feed_pref.google_remarketing.daily_budget : this.state.google_selected_daily_budget,
                tiktok_selected_daily_budget: response.feed_pref.tiktok_remarketing.daily_budget ? response.feed_pref.tiktok_remarketing.daily_budget : this.state.tiktok_selected_daily_budget,
                snapchat_selected_daily_budget: response.feed_pref.snapchat_remarketing.daily_budget ? response.feed_pref.snapchat_remarketing.daily_budget : this.state.snapchat_selected_daily_budget,
                facebook_feed_status: response.feed_pref.facebook_remarketing.status ? response.feed_pref.facebook_remarketing.status : this.state.facebook_feed_status,
                google_feed_status: response.feed_pref.google_remarketing.status ? response.feed_pref.google_remarketing.status : this.state.google_feed_status,
                tiktok_feed_status: response.feed_pref.tiktok_remarketing.status ? response.feed_pref.tiktok_remarketing.status : this.state.tiktok_feed_status,
                snapchat_feed_status: response.feed_pref.snapchat_remarketing.status ? response.feed_pref.snapchat_remarketing.status : this.state.snapchat_feed_status,
                isLoading: false,
                reseller_id: response.id
            });
        }, (error) => {
            this.setState({isLoading: false, error: true})
        });
    }

    _updateUser() {
        let user = userRegister.get();
        try {
        if (user) {
            this.setState({
                email: user.email,
                name: user.name + " " + user.surname
            });
        }
        } catch (e) {
        }
    }

    _updateFeed() {
        dataRegister.getFeed(salesChannelRegister.get('market'), langRegister.lang(), salesChannelRegister.get("name")).then((response) => {

            let data = [];
            let all = [];

            try {
                for (let i = 0; i < response.length; i++) {
                    try {
                        response[i].data.date = moment(response[i].data.created_at).format('YYYYMMDD');
                    } catch (e) {
                    }
                    all.push(response[i].data);

                    // Filter on seller and if feed data must exist

                        try {
                            //console.log(response[i].data);
                            let reseller_id = response[i].data.reseller_id;
                            if (reseller_id === this.state.reseller_id && response[i].data.landing_extra.feed_data) {
                                data.push(response[i].data);
                            }
                        } catch (e) {
                            console.log(e);
                        }

                }

                //console.log(data);

                if (Array.isArray(data) && data.length > 2) {

                    //Display all related
                    this.setState({
                        feed_properties: data.filter((item) => {
                            return item.industry && !item.expired
                        }),
                        feed_loader: false
                    });
                } else {
                    this.setState({
                        feed_properties: [],
                        feed_loader: false
                    });
                }
            } catch (e) {
                this.setState({
                    feed_properties: [],
                    feed_loader: false
               });
            }
        }, (error) => {

            console.log(error)

        });
    }

    _setSmartSpend(){
        //TODO: add edit account and send internal notification functionality
        //NOTE: currently smart spend is mandatory
            this.setState({
                switchLoader: true,
                smartspend_feed_status: !this.state.smartspend_feed_status
            }, () => {
                this.setState({
                    switchLoader: false
                });
            });
    }

    _setSearchFeed(){
        //TODO: add edit account and send internal notification functionality
        //NOTE: currently smart spend is mandatory
        this.setState({
            switchLoader: true,
            search_feed_status: !this.state.search_feed_status
        }, () => {
            this.setState({
                switchLoader: false
            });
        });
    }

    _setProptree(){
        //TODO: add edit account and send internal notification functionality
        //NOTE: proptree is optional but always available
        this.setState({
            switchLoader: true,
            proptree_status: !this.state.proptree_status
        }, () => {
            this.setState({
                switchLoader: false
            });
        });
    }

    _setFacebookFeed(){
        if (this.state.edit_facebook) {
        this.setState({
            switchLoader: true,
            facebook_feed_status: !this.state.facebook_feed_status
        }, () => {
                this.setState({
                    switchLoader: false
                });
        });
        }
    }

    _setGoogleFeed(){
        if (this.state.edit_google) {
            this.setState({
                switchLoader: true,
                google_feed_status: !this.state.google_feed_status
            }, () => {
                this.setState({
                    switchLoader: false
                });
            });
        }
    }

    _setTiktokFeed(){
        if (this.state.edit_tiktok) {
            this.setState({
                switchLoader: true,
                tiktok_feed_status: !this.state.tiktok_feed_status
            }, () => {
                this.setState({
                    switchLoader: false
                });
            });
        }
    }

    _setSnapchatFeed(){
        if (this.state.edit_snapchat) {
            this.setState({
                switchLoader: true,
                snapchat_feed_status: !this.state.snapchat_feed_status
            }, () => {
                this.setState({
                    switchLoader: false
                });
            });
        }
    }

    _saveFacebookFeed(){
        if (this.state.edit_facebook) {
            this.setState({edit_facebook: !this.state.edit_facebook}, () => {
                let data = {email: this.state.email, name: this.state.name, subject: salesChannelRegister.get("name")+" facebook feed request", message: ' set facebook feed to ' + this.state.facebook_feed_status + (this.state.facebook_feed_status ? ' and daily budget to ' + this.state.facebook_selected_daily_budget + ' ' + this.state.currency : '')};
                dataRegister.industryRequest(salesChannelRegister.get('market'), salesChannelRegister.get("name"), data).then((response) => {
                    this.setState({
                        feed_pref: {
                            facebook_remarketing: {daily_budget: this.state.facebook_selected_daily_budget, status: this.state.facebook_feed_status},
                            google_remarketing: {daily_budget: this.state.google_selected_daily_budget, status: this.state.google_feed_status},
                            tiktok_remarketing: {daily_budget: this.state.tiktok_selected_daily_budget, status: this.state.tiktok_feed_status},
                            snapchat_remarketing: {daily_budget: this.state.snapchat_selected_daily_budget, status: this.state.snapchat_feed_status}
                        }
                    });
                    this._changeAccount();
                }, (error) => {
                    this.setState({
                        error: true
                    });
                });
            });
        } else {
            this.setState({edit_facebook: true});
        }
    }

    _saveGoogleFeed(){
        if (this.state.edit_google) {
            this.setState({edit_google: !this.state.edit_google}, () => {
                let data = {email: this.state.email, name: this.state.name, subject: salesChannelRegister.get("name")+" google feed request", message: ' set google feed to ' + this.state.google_feed_status + (this.state.google_feed_status ? ' and daily budget to ' + this.state.google_selected_daily_budget + ' ' + this.state.currency : '')};
                dataRegister.industryRequest(salesChannelRegister.get('market'), salesChannelRegister.get("name"), data).then((response) => {
                    this.setState({
                        feed_pref: {
                            facebook_remarketing: {daily_budget: this.state.facebook_selected_daily_budget, status: this.state.facebook_feed_status},
                            google_remarketing: {daily_budget: this.state.google_selected_daily_budget, status: this.state.google_feed_status},
                            tiktok_remarketing: {daily_budget: this.state.tiktok_selected_daily_budget, status: this.state.tiktok_feed_status},
                            snapchat_remarketing: {daily_budget: this.state.snapchat_selected_daily_budget, status: this.state.snapchat_feed_status}
                        }
                    });
                    this._changeAccount();
                }, (error) => {
                    this.setState({
                        error: true
                    });
                });
            });
        } else {
            this.setState({edit_google: true});
        }
    }

    _saveTiktokFeed(){
        if (this.state.edit_tiktok) {
            this.setState({edit_tiktok: !this.state.edit_tiktok}, () => {
                let data = {email: this.state.email, name: this.state.name, subject: salesChannelRegister.get("name")+" tiktok feed request", message: ' set tiktok feed to ' + this.state.tiktok_feed_status + (this.state.tiktok_feed_status ? ' and daily budget to ' + this.state.tiktok_selected_daily_budget + ' ' + this.state.currency : '')};
                dataRegister.industryRequest(salesChannelRegister.get('market'), salesChannelRegister.get("name"), data).then((response) => {
                    this.setState({
                        feed_pref: {
                            facebook_remarketing: {daily_budget: this.state.facebook_selected_daily_budget, status: this.state.facebook_feed_status},
                            google_remarketing: {daily_budget: this.state.google_selected_daily_budget, status: this.state.google_feed_status},
                            tiktok_remarketing: {daily_budget: this.state.tiktok_selected_daily_budget, status: this.state.tiktok_feed_status},
                            snapchat_remarketing: {daily_budget: this.state.snapchat_selected_daily_budget, status: this.state.snapchat_feed_status}
                        }
                    });
                    this._changeAccount();
                }, (error) => {
                    this.setState({
                        error: true
                    });
                });
            });
        } else {
            this.setState({edit_tiktok: true});
        }
    }

    _saveSnapchatFeed(){
        if (this.state.edit_snapchat) {
            this.setState({edit_snapchat: !this.state.edit_snapchat}, () => {
                let data = {email: this.state.email, name: this.state.name, subject: salesChannelRegister.get("name")+" snapchat feed request", message: ' set snapchat feed to ' + this.state.snapchat_feed_status + (this.state.snapchat_feed_status ? ' and daily budget to ' + this.state.snapchat_selected_daily_budget + ' ' + this.state.currency : '')};
                dataRegister.industryRequest(salesChannelRegister.get('market'), salesChannelRegister.get("name"), data).then((response) => {
                    this.setState({
                        feed_pref: {
                            facebook_remarketing: {daily_budget: this.state.facebook_selected_daily_budget, status: this.state.facebook_feed_status},
                            google_remarketing: {daily_budget: this.state.google_selected_daily_budget, status: this.state.google_feed_status},
                            tiktok_remarketing: {daily_budget: this.state.tiktok_selected_daily_budget, status: this.state.tiktok_feed_status},
                            snapchat_remarketing: {daily_budget: this.state.snapchat_selected_daily_budget, status: this.state.snapchat_feed_status}
                        }
                    });
                    this._changeAccount();
                }, (error) => {
                    this.setState({
                        error: true
                    });
                });
            });
        } else {
            this.setState({edit_snapchat: true});
        }
    }

    _changeAccount() {
        if (!this.state.isLoading) {
            this.setState({
                isLoading: true,
            });
            let data = {
                feed_pref: this.state.feed_pref
            };
            dataRegister.editAccount(salesChannelRegister.get('market'), data).then((item) => {
                this.setState({isLoading: false}, () => {
                    let user = userRegister.get();
                    user.feed_pref = item.feed_pref;
                    userRegister.set(user);
                });
            }, (error) => {
                this.setState({isLoading: false, error: true})
            });
        }
    }


    _renderText(item) {
        return langRegister.get("user-feeds", item);
    }

    render() {
        return (
            <div>
                <div className={Styles.contentHeader}>
                    <div className={Styles.contentHeaderSearch}>

                    </div>
                    <LanguageButton props={this.props}/>
                    <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                        {this._renderText("item_1")}
                    </div>
                </div>
                <div className={Styles.container}>
                    {
                        !this.state.isLoading && !this.state.error &&
                        <div className={Styles.containerInner}>
                            <div className={Styles.contentInnerItem}>
                                <div className={Styles.contentInnerItemHeader}>
                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                        {this._renderText("item_9")}
                                    </div>
                                    <div style={{justifyContent: 'flex-end'}} className={cx(Styles.summaryContainerItemFeed)}>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' &&
                                            (this.state.smartspend_feed_status && !this.state.switchLoader) &&
                                            <img onClick={() => this._setSmartSpend()}
                                                 style={{marginRight: '0px'}}
                                                 className={Styles.summaryContainerItemFeedIcon}
                                                 src={require("../../assets/images/push_black_on.svg")}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' &&
                                            (this.state.smartspend_feed_status && !this.state.switchLoader) &&
                                            <img onClick={() => this._setSmartSpend()}
                                                 style={{marginRight: '0px'}}
                                                 className={Styles.summaryContainerItemFeedIcon}
                                                 src={require("../../assets/images/slider_active_yl.svg")}/>
                                        }
                                        {
                                            !this.state.smartspend_feed_status && !this.state.switchLoader &&
                                            <img onClick={() => this._setSmartSpend()}
                                                 style={{marginRight: '0px'}}
                                                 className={Styles.summaryContainerItemFeedIcon}
                                                 src={require("../../assets/images/slider_deactive.svg")}/>
                                        }
                                        {
                                            this.state.switchLoader &&
                                            <BeatLoader size={15} color={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{color: '#000000'}} loading={true}/>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                this.state.smartspend_feed_status &&
                            <div className={Styles.contentInnerItem}>
                                <div className={Styles.contentInnerItemHeader}>
                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                        {this._renderText("item_10")}
                                    </div>
                                    <div style={{justifyContent: 'flex-end'}} className={cx(Styles.summaryContainerItemFeed)}>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' &&
                                            (this.state.search_feed_status && !this.state.switchLoader) &&
                                            <img onClick={() => this._setSearchFeed()}
                                                 style={{marginRight: '0px'}}
                                                 className={Styles.summaryContainerItemFeedIcon}
                                                 src={require("../../assets/images/push_black_on.svg")}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' &&
                                            (this.state.search_feed_status && !this.state.switchLoader) &&
                                            <img onClick={() => this._setSearchFeed()}
                                                 style={{marginRight: '0px'}}
                                                 className={Styles.summaryContainerItemFeedIcon}
                                                 src={require("../../assets/images/slider_active_yl.svg")}/>
                                        }
                                        {
                                            !this.state.search_feed_status && !this.state.switchLoader &&
                                            <img onClick={() => this._setSearchFeed()}
                                                 style={{marginRight: '0px'}}
                                                 className={Styles.summaryContainerItemFeedIcon}
                                                 src={require("../../assets/images/slider_deactive.svg")}/>
                                        }
                                        {
                                            this.state.switchLoader &&
                                            <BeatLoader size={15} color={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{color: '#000000'}} loading={true}/>
                                        }
                                    </div>
                                </div>
                            </div>
                            }
                            {
                                <div className={Styles.contentInnerItem}>
                                    <div className={Styles.contentInnerItemHeader}>
                                        <div className={Styles.contentInnerItemHeaderTitle}>
                                            {this._renderText("item_11")}
                                        </div>
                                        <div style={{justifyContent: 'flex-end'}} className={cx(Styles.summaryContainerItemFeed)}>
                                            {
                                                salesChannelRegister.get('name') !== 'yieldlock' &&
                                                (this.state.proptree_status && !this.state.switchLoader) &&
                                                <img //onClick={() => this._setProptree()}
                                                     style={{marginRight: '0px', cursor: 'not-allowed'}}
                                                     className={Styles.summaryContainerItemFeedIcon}
                                                     src={require("../../assets/images/push_black_on.svg")}/>
                                            }
                                            {
                                                salesChannelRegister.get('name') === 'yieldlock' &&
                                                (this.state.proptree_status && !this.state.switchLoader) &&
                                                <img //onClick={() => this._setProptree()}
                                                     style={{marginRight: '0px', cursor: 'not-allowed'}}
                                                     className={Styles.summaryContainerItemFeedIcon}
                                                     src={require("../../assets/images/slider_active_yl.svg")}/>
                                            }
                                            {
                                                !this.state.proptree_status && !this.state.switchLoader &&
                                                <img //onClick={() => this._setProptree()}
                                                     style={{marginRight: '0px', cursor: 'not-allowed'}}
                                                     className={Styles.summaryContainerItemFeedIcon}
                                                     src={require("../../assets/images/slider_deactive.svg")}/>
                                            }
                                            {
                                                this.state.switchLoader &&
                                                <BeatLoader size={15} color={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{color: '#000000'}} loading={true}/>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className={Styles.contentInnerItem}>
                                <div className={Styles.contentInnerItemHeader}>
                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                        {this._renderText("item_2") + " (" + this.state.feed_properties.length + ")"}
                                    </div>
                                    <div onClick={() => this._saveFacebookFeed()} className={cx(Styles.contentInnerItemHeaderEdit,
                                            {
                                                [Styles.contentInnerItemHeaderEditActive]: this.state.edit_facebook
                                            })
                                    }>
                                        {!this.state.edit_facebook && this._renderText("item_3")}
                                        {this.state.edit_facebook && this._renderText("item_4")}
                                    </div>
                                    {
                                        !this.state.edit_facebook &&
                                        <div onClick={() => this._saveFacebookFeed()} className={Styles.contentInnerItemHeaderEditMobile}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                    {
                                        this.state.edit_facebook &&
                                        <div onClick={() => this._saveFacebookFeed()} className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div style={salesChannelRegister.get('name')==='yieldlock'?{backgroundColor: '#00273A'}:{}} className={
                                             cx(Styles.iconsContainerItem,
                                                 {
                                                     [Styles.iconsContainerItemDisabled]: !this.state.facebook_feed_status
                                                 })
                                         }>
                                        <img className={Styles.iconsContainerItemFacebook}
                                             src={require('../../assets/images/facebook_logo_icon.svg')}/>
                                    </div>
                                    <div className={cx(Styles.summaryContainerItemFeed)}>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' &&
                                            (this.state.facebook_feed_status && !this.state.switchLoader) &&
                                            <img onClick={() => this._setFacebookFeed()}
                                                 className={
                                                     cx(Styles.summaryContainerItemFeedIcon,
                                                         {
                                                             [Styles.summaryContainerItemFeedIconDisabled]: !this.state.edit_facebook,
                                                         })}
                                                 src={require("../../assets/images/push_black_on.svg")}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' &&
                                            (this.state.facebook_feed_status && !this.state.switchLoader) &&
                                            <img onClick={() => this._setFacebookFeed()}
                                                 className={
                                                     cx(Styles.summaryContainerItemFeedIcon,
                                                         {
                                                             [Styles.summaryContainerItemFeedIconDisabled]: !this.state.edit_facebook,
                                                         })}
                                                 src={require("../../assets/images/slider_active_yl.svg")}/>
                                        }
                                        {
                                            !this.state.facebook_feed_status && !this.state.switchLoader &&
                                            <img onClick={() => this._setFacebookFeed()}
                                                 className={
                                                     cx(Styles.summaryContainerItemFeedIcon,
                                                         {
                                                             [Styles.summaryContainerItemFeedIconDisabled]: !this.state.edit_facebook,
                                                         })}
                                                 src={require("../../assets/images/slider_deactive.svg")}/>
                                        }
                                        {
                                            this.state.switchLoader &&
                                            <BeatLoader size={15} color={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{color: '#000000'}} loading={true}/>
                                        }
                                    </div>
                                    {
                                        this.state.facebook_feed_status &&
                                    <div className={Styles.inputDividerItem}>
                                        <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={
                                            cx(Styles.dropdownSelectionTitle,
                                                {
                                                    [Styles.dropdownSelectionTitleDisabled]: !this.state.edit_facebook,
                                                })
                                        }>
                                            {this._renderText("item_5")}
                                        </div>
                                        <div className={
                                            cx(Styles.dropdown,
                                                {
                                                    [Styles.dropdownDisabled]: !this.state.edit_facebook,
                                                })
                                        }>
                                            <select disabled={!this.state.edit_facebook} className={
                                                cx(Styles.dropdownSelection,
                                                    {
                                                        [Styles.dropdownSelectionDisabled]: !this.state.edit_facebook,
                                                    })} value={this.state.facebook_selected_daily_budget} onChange={(event) => this.setState({facebook_selected_daily_budget: event.target.value})}>
                                                {
                                                    this.state.daily_budget.map((item) => {
                                                        return(
                                                            <option value={item}>{item + ' ' + this.state.currency}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.dropdownText}>
                                                {this.state.facebook_selected_daily_budget + ' ' + this.state.currency}
                                            </div>
                                            {
                                                salesChannelRegister.get('name') !== "yieldlock" &&
                                                <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down.svg")}/>
                                            }
                                            {
                                                salesChannelRegister.get('name') === "yieldlock" &&
                                                <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-yl.svg")}/>
                                            }
                                        </div>
                                    </div>
                                    }
                                </div>
                                {
                                    (this.state.feed_properties.length > 2 || this.state.feed_loader) &&
                                    <div className={
                                        cx(Styles.feedContainer,
                                            {
                                                [Styles.feedContainerDisabled]: !this.state.facebook_feed_status,
                                            })
                                    }>
                                        {
                                            !this.state.feed_loader &&
                                            <Feed
                                                items={this.state.feed_properties}
                                            />
                                        }
                                        {
                                            this.state.feed_loader &&
                                            <BeatLoader size={30} color={'var(--first-color)'} loading={true} />
                                        }
                                    </div>
                                }
                            </div>
                            <div className={Styles.contentInnerItem}>
                                <div className={Styles.contentInnerItemHeader}>
                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                        {this._renderText("item_6") + " (" + this.state.feed_properties.length + ")"}
                                    </div>
                                    <div onClick={() => this._saveGoogleFeed()} className={cx(Styles.contentInnerItemHeaderEdit,
                                        {
                                            [Styles.contentInnerItemHeaderEditActive]: this.state.edit_google
                                        })
                                    }>
                                        {!this.state.edit_google && this._renderText("item_3")}
                                        {this.state.edit_google && this._renderText("item_4")}
                                    </div>
                                    {
                                        !this.state.edit_google &&
                                        <div onClick={() => this._saveGoogleFeed()} className={Styles.contentInnerItemHeaderEditMobile}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                    {
                                        this.state.edit_google &&
                                        <div onClick={() => this._saveGoogleFeed()} className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div style={salesChannelRegister.get('name')==='yieldlock'?{backgroundColor: '#00273A'}:{}} className={
                                        cx(Styles.iconsContainerItem,
                                            {
                                                [Styles.iconsContainerItemDisabled]: !this.state.google_feed_status
                                            })
                                    }>
                                        <img className={Styles.iconsContainerItemGoogle}
                                             src={require('../../assets/images/google_logo_icon.svg')}/>
                                    </div>
                                    <div className={cx(Styles.summaryContainerItemFeed)}>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' &&
                                            (this.state.google_feed_status && !this.state.switchLoader) &&
                                            <img onClick={() => this._setGoogleFeed()}
                                                 className={
                                                     cx(Styles.summaryContainerItemFeedIcon,
                                                         {
                                                             [Styles.summaryContainerItemFeedIconDisabled]: !this.state.edit_google,
                                                         })}
                                                 src={require("../../assets/images/push_black_on.svg")}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' &&
                                            (this.state.google_feed_status && !this.state.switchLoader) &&
                                            <img onClick={() => this._setGoogleFeed()}
                                                 className={
                                                     cx(Styles.summaryContainerItemFeedIcon,
                                                         {
                                                             [Styles.summaryContainerItemFeedIconDisabled]: !this.state.edit_google,
                                                         })}
                                                 src={require("../../assets/images/slider_active_yl.svg")}/>
                                        }
                                        {
                                            !this.state.google_feed_status && !this.state.switchLoader &&
                                            <img onClick={() => this._setGoogleFeed()}
                                                 className={
                                                     cx(Styles.summaryContainerItemFeedIcon,
                                                         {
                                                             [Styles.summaryContainerItemFeedIconDisabled]: !this.state.edit_google,
                                                         })}
                                                 src={require("../../assets/images/slider_deactive.svg")}/>
                                        }
                                        {
                                            this.state.switchLoader &&
                                            <BeatLoader size={15} color={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{color: '#000000'}} loading={true}/>
                                        }
                                    </div>
                                    {
                                        this.state.google_feed_status &&
                                        <div className={Styles.inputDividerItem}>
                                            <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={
                                                cx(Styles.dropdownSelectionTitle,
                                                    {
                                                        [Styles.dropdownSelectionTitleDisabled]: !this.state.edit_google,
                                                    })
                                            }>
                                                {this._renderText("item_5")}
                                            </div>
                                            <div className={
                                                cx(Styles.dropdown,
                                                    {
                                                        [Styles.dropdownDisabled]: !this.state.edit_google,
                                                    })
                                            }>
                                                <select disabled={!this.state.edit_google} className={
                                                    cx(Styles.dropdownSelection,
                                                        {
                                                            [Styles.dropdownSelectionDisabled]: !this.state.edit_google,
                                                        })} value={this.state.google_selected_daily_budget} onChange={(event) => this.setState({google_selected_daily_budget: event.target.value})}>
                                                    {
                                                        this.state.daily_budget.map((item) => {
                                                            return(
                                                                <option value={item}>{item + ' ' + this.state.currency}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.dropdownText}>
                                                    {this.state.google_selected_daily_budget + ' ' + this.state.currency}
                                                </div>
                                                {
                                                    salesChannelRegister.get('name') !== "yieldlock" &&
                                                    <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down.svg")}/>
                                                }
                                                {
                                                    salesChannelRegister.get('name') === "yieldlock" &&
                                                    <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-yl.svg")}/>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                                {
                                    (this.state.feed_properties.length > 2 || this.state.feed_loader) &&
                                    <div className={
                                        cx(Styles.feedContainer,
                                            {
                                                [Styles.feedContainerDisabled]: !this.state.google_feed_status,
                                            })
                                    }>
                                        {
                                            !this.state.feed_loader &&
                                            <Feed
                                                items={this.state.feed_properties}
                                            />
                                        }
                                        {
                                            this.state.feed_loader &&
                                            <BeatLoader size={30} color={'var(--first-color)'} loading={true} />
                                        }
                                    </div>
                                }
                            </div>
                            <div className={Styles.contentInnerItem}>
                                <div className={Styles.contentInnerItemHeader}>
                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                        {this._renderText("item_7") + " (" + this.state.feed_properties.length + ")"}
                                    </div>
                                    <div onClick={() => this._saveTiktokFeed()} className={cx(Styles.contentInnerItemHeaderEdit,
                                        {
                                            [Styles.contentInnerItemHeaderEditActive]: this.state.edit_tiktok
                                        })
                                    }>
                                        {!this.state.edit_tiktok && this._renderText("item_3")}
                                        {this.state.edit_tiktok && this._renderText("item_4")}
                                    </div>
                                    {
                                        !this.state.edit_tiktok &&
                                        <div onClick={() => this._saveTiktokFeed()} className={Styles.contentInnerItemHeaderEditMobile}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                    {
                                        this.state.edit_tiktok &&
                                        <div onClick={() => this._saveTiktokFeed()} className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div style={salesChannelRegister.get('name')==='yieldlock'?{backgroundColor: '#00273A'}:{}} className={
                                        cx(Styles.iconsContainerItem,
                                            {
                                                [Styles.iconsContainerItemDisabled]: !this.state.tiktok_feed_status
                                            })
                                    }>
                                        <img className={Styles.iconsContainerItemTiktok}
                                             src={require('../../assets/images/tiktok_logo_icon.svg')}/>
                                    </div>
                                    <div className={cx(Styles.summaryContainerItemFeed)}>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' &&
                                            (this.state.tiktok_feed_status && !this.state.switchLoader) &&
                                            <img onClick={() => this._setTiktokFeed()}
                                                 className={
                                                     cx(Styles.summaryContainerItemFeedIcon,
                                                         {
                                                             [Styles.summaryContainerItemFeedIconDisabled]: !this.state.edit_tiktok,
                                                         })}
                                                 src={require("../../assets/images/push_black_on.svg")}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' &&
                                            (this.state.tiktok_feed_status && !this.state.switchLoader) &&
                                            <img onClick={() => this._setTiktokFeed()}
                                                 className={
                                                     cx(Styles.summaryContainerItemFeedIcon,
                                                         {
                                                             [Styles.summaryContainerItemFeedIconDisabled]: !this.state.edit_tiktok,
                                                         })}
                                                 src={require("../../assets/images/slider_active_yl.svg")}/>
                                        }
                                        {
                                            !this.state.tiktok_feed_status && !this.state.switchLoader &&
                                            <img onClick={() => this._setTiktokFeed()}
                                                 className={
                                                     cx(Styles.summaryContainerItemFeedIcon,
                                                         {
                                                             [Styles.summaryContainerItemFeedIconDisabled]: !this.state.edit_tiktok,
                                                         })}
                                                 src={require("../../assets/images/slider_deactive.svg")}/>
                                        }
                                        {
                                            this.state.switchLoader &&
                                            <BeatLoader size={15} color={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{color: '#000000'}} loading={true}/>
                                        }
                                    </div>
                                    {
                                        this.state.tiktok_feed_status &&
                                        <div className={Styles.inputDividerItem}>
                                            <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={
                                                cx(Styles.dropdownSelectionTitle,
                                                    {
                                                        [Styles.dropdownSelectionTitleDisabled]: !this.state.edit_tiktok,
                                                    })
                                            }>
                                                {this._renderText("item_5")}
                                            </div>
                                            <div className={
                                                cx(Styles.dropdown,
                                                    {
                                                        [Styles.dropdownDisabled]: !this.state.edit_tiktok,
                                                    })
                                            }>
                                                <select disabled={!this.state.edit_tiktok} className={
                                                    cx(Styles.dropdownSelection,
                                                        {
                                                            [Styles.dropdownSelectionDisabled]: !this.state.edit_tiktok,
                                                        })} value={this.state.tiktok_selected_daily_budget} onChange={(event) => this.setState({tiktok_selected_daily_budget: event.target.value})}>
                                                    {
                                                        this.state.daily_budget.map((item) => {
                                                            return(
                                                                <option value={item}>{item + ' ' + this.state.currency}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.dropdownText}>
                                                    {this.state.tiktok_selected_daily_budget + ' ' + this.state.currency}
                                                </div>
                                                {
                                                    salesChannelRegister.get('name') !== "yieldlock" &&
                                                    <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down.svg")}/>
                                                }
                                                {
                                                    salesChannelRegister.get('name') === "yieldlock" &&
                                                    <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-yl.svg")}/>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                                {
                                    (this.state.feed_properties.length > 2 || this.state.feed_loader) &&
                                    <div className={
                                        cx(Styles.feedContainer,
                                            {
                                                [Styles.feedContainerDisabled]: !this.state.tiktok_feed_status,
                                            })
                                    }>
                                        {
                                            !this.state.feed_loader &&
                                            <Feed
                                                items={this.state.feed_properties}
                                            />
                                        }
                                        {
                                            this.state.feed_loader &&
                                            <BeatLoader size={30} color={'var(--first-color)'} loading={true} />
                                        }
                                    </div>
                                }
                            </div>
                            <div className={Styles.contentInnerItem}>
                                <div className={Styles.contentInnerItemHeader}>
                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                        {this._renderText("item_8") + " (" + this.state.feed_properties.length + ")"}
                                    </div>
                                    <div onClick={() => this._saveSnapchatFeed()} className={cx(Styles.contentInnerItemHeaderEdit,
                                        {
                                            [Styles.contentInnerItemHeaderEditActive]: this.state.edit_snapchat
                                        })
                                    }>
                                        {!this.state.edit_snapchat && this._renderText("item_3")}
                                        {this.state.edit_snapchat && this._renderText("item_4")}
                                    </div>
                                    {
                                        !this.state.edit_snapchat &&
                                        <div onClick={() => this._saveSnapchatFeed()} className={Styles.contentInnerItemHeaderEditMobile}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                    {
                                        this.state.edit_snapchat &&
                                        <div onClick={() => this._saveSnapchatFeed()} className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div style={salesChannelRegister.get('name')==='yieldlock'?{backgroundColor: '#00273A'}:{}} className={
                                        cx(Styles.iconsContainerItem,
                                            {
                                                [Styles.iconsContainerItemDisabled]: !this.state.snapchat_feed_status
                                            })
                                    }>
                                        <img className={Styles.iconsContainerItemSnapchat}
                                             src={require('../../assets/images/snapchat_logo_icon.svg')}/>
                                    </div>
                                    <div className={cx(Styles.summaryContainerItemFeed)}>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' &&
                                            (this.state.snapchat_feed_status && !this.state.switchLoader) &&
                                            <img onClick={() => this._setSnapchatFeed()}
                                                 className={
                                                     cx(Styles.summaryContainerItemFeedIcon,
                                                         {
                                                             [Styles.summaryContainerItemFeedIconDisabled]: !this.state.edit_snapchat,
                                                         })}
                                                 src={require("../../assets/images/push_black_on.svg")}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' &&
                                            (this.state.snapchat_feed_status && !this.state.switchLoader) &&
                                            <img onClick={() => this._setSnapchatFeed()}
                                                 className={
                                                     cx(Styles.summaryContainerItemFeedIcon,
                                                         {
                                                             [Styles.summaryContainerItemFeedIconDisabled]: !this.state.edit_snapchat,
                                                         })}
                                                 src={require("../../assets/images/slider_active_yl.svg")}/>
                                        }
                                        {
                                            !this.state.snapchat_feed_status && !this.state.switchLoader &&
                                            <img onClick={() => this._setSnapchatFeed()}
                                                 className={
                                                     cx(Styles.summaryContainerItemFeedIcon,
                                                         {
                                                             [Styles.summaryContainerItemFeedIconDisabled]: !this.state.edit_snapchat,
                                                         })}
                                                 src={require("../../assets/images/slider_deactive.svg")}/>
                                        }
                                        {
                                            this.state.switchLoader &&
                                            <BeatLoader size={15} color={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{color: '#000000'}} loading={true}/>
                                        }
                                    </div>
                                    {
                                        this.state.snapchat_feed_status &&
                                        <div className={Styles.inputDividerItem}>
                                            <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={
                                                cx(Styles.dropdownSelectionTitle,
                                                    {
                                                        [Styles.dropdownSelectionTitleDisabled]: !this.state.edit_snapchat,
                                                    })
                                            }>
                                                {this._renderText("item_5")}
                                            </div>
                                            <div className={
                                                cx(Styles.dropdown,
                                                    {
                                                        [Styles.dropdownDisabled]: !this.state.edit_snapchat,
                                                    })
                                            }>
                                                <select disabled={!this.state.edit_snapchat} className={
                                                    cx(Styles.dropdownSelection,
                                                        {
                                                            [Styles.dropdownSelectionDisabled]: !this.state.edit_snapchat,
                                                        })} value={this.state.snapchat_selected_daily_budget} onChange={(event) => this.setState({snapchat_selected_daily_budget: event.target.value})}>
                                                    {
                                                        this.state.daily_budget.map((item) => {
                                                            return(
                                                                <option value={item}>{item + ' ' + this.state.currency}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.dropdownText}>
                                                    {this.state.snapchat_selected_daily_budget + ' ' + this.state.currency}
                                                </div>
                                                {
                                                    salesChannelRegister.get('name') !== "yieldlock" &&
                                                    <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down.svg")}/>
                                                }
                                                {
                                                    salesChannelRegister.get('name') === "yieldlock" &&
                                                    <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-yl.svg")}/>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                                {
                                    (this.state.feed_properties.length > 2 || this.state.feed_loader) &&
                                    <div className={
                                        cx(Styles.feedContainer,
                                            {
                                                [Styles.feedContainerDisabled]: !this.state.snapchat_feed_status,
                                            })
                                    }>
                                        {
                                            !this.state.feed_loader &&
                                            <Feed
                                                items={this.state.feed_properties}
                                            />
                                        }
                                        {
                                            this.state.feed_loader &&
                                            <BeatLoader size={30} color={'var(--first-color)'} loading={true} />
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    {
                        this.state.isLoading &&
                        <div className={Styles.loader}>
                            <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.error &&
                        <div className={Styles.loader}>
                            <ErrorHandler/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default userFeeds;


// WEBPACK FOOTER //
// ./src/components/user-feeds/component.js